<div class="container mt-2">

  <div class="text-center mt-3 mb-4">
    <strong class="mainHeading">Mobile Users Dashboard</strong>
  </div>

  <div class="card shadow-lg p-3">
    <div class="container pt-4" style="font-size: 1.5rem;color: black;background-color: #d4edda;border-radius: 20px;">
      <strong>Overall Users</strong>
      <div class="row d-flex justify-content-around mt-4 mb-5 pb-5">

        <div class="col-md-3">
          <div class="card shadow-sm dashboard-card" style="background-color: #F8ECC8;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-lines-fill fa-2x me-3 empPermission" style="color: #AD870C !important;"></i>
                <div class="ms-auto text-end ">
                  <h3 class="card-title mb-0 text-center empPermission ">{{totalUsers?.totalMobileUser}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text empPermission">Users</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 ms-2">
          <div class="card shadow-sm dashboard-card" style=" background: #DCFFDDF7;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-check fa-2x me-3 empPresent" style="color: #2D702F !important;"></i>
                <div class="ms-auto text-end">
                  <h3 class="card-title mb-0 text-center empPresent">{{totalUsers?.totalOnBusinessUsers}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text empPresent">On Business</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 ms-2">
          <div class="card shadow-sm dashboard-card" style="background-color: #F8D7E5;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-slash fa-2x me-3 totalEmployees" style="color: #9B1B30 !important;"></i>
                <div class="ms-auto text-end">
                  <h3 class="card-title mb-0 text-center totalEmployees">{{totalUsers?.totalOffBusinessUsers}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text totalEmployees">Off Business</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card shadow-lg p-3">
    <div class="container pt-4" style="font-size: 1.5rem;color: black;background-color: #ADD8E6;border-radius: 20px;">
      <strong>Android Users</strong>
      <div class="row d-flex justify-content-around mt-4">

        <div class="col-md-3">
          <div class="card shadow-sm dashboard-card" style="background-color: #F8ECC8;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-lines-fill fa-2x me-3 empPermission" style="color: #AD870C !important;"></i>
                <div class="ms-auto text-end ">
                  <h3 class="card-title mb-0 text-center empPermission">{{androidUsers?.androidMobileUser}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text empPermission">Total Users</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 ms-2">
          <div class="card shadow-sm dashboard-card" style=" background: #DCFFDDF7;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-check fa-2x me-3 empPresent" style="color: #2D702F !important;"></i>
                <div class="ms-auto text-end">
                  <h3 class="card-title mb-0 text-center empPresent">{{androidUsers?.androidOnBusinessUsers}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text empPresent">On Business</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 ms-2">
          <div class="card shadow-sm dashboard-card" style="background-color: #F8D7E5;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-slash fa-2x me-3 totalEmployees" style="color: #9B1B30 !important;"></i>
                <div class="ms-auto text-end">
                  <h3 class="card-title mb-0 text-center totalEmployees">{{androidUsers?.androidOffBusinessUsers}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text totalEmployees">Off Business</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5 mb-5 pb-5" style="justify-content: center;gap: 50px;">
        <div class="col-lg-5 col-md-6 col-12 mt-2">
          <div class="card p-3 shadow" style="background-color: white;color: black;">
            <apx-chart [series]="chartSeries" [chart]="chartOptions" [labels]="chartLabels" [dataLabels]="dataLabels"
              [title]="title" [colors]="colors" [plotOptions]="plotOptions">
            </apx-chart>
          </div>
        </div>
        <div class="col-lg-5 col-md-6 col-12 mt-2">
          <div class="card p-3 shadow" style="background-color: white;color: black;">
            <apx-chart [series]="chartSeries2" [chart]="chartOptions2" [labels]="chartLabels2"
              [dataLabels]="dataLabels2" [title]="title2" [colors]="colors2" [plotOptions]="plotOptions2">
            </apx-chart>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-lg p-3">
    <div class="container mt-7 pt-4"
      style="font-size: 1.5rem;color: black; background-color: #E6E6FA;border-radius: 20px;">
      <strong>IOS Users</strong>
      <div class="row d-flex justify-content-around mt-4">

        <div class="col-md-3">
          <div class="card shadow-sm dashboard-card" style="background-color: #F8ECC8;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-lines-fill fa-2x me-3 empPermission" style="color: #AD870C !important;"></i>
                <div class="ms-auto text-end ">
                  <h3 class="card-title mb-0 text-center empPermission">{{iosUsers?.iosMobileUser}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text empPermission">Total Users</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 ms-2">
          <div class="card shadow-sm dashboard-card" style=" background: #DCFFDDF7;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-check fa-2x me-3 empPresent" style="color: #2D702F !important;"></i>
                <div class="ms-auto text-end">
                  <h3 class="card-title mb-0 text-center empPresent">{{iosUsers?.iosOnBusinessUsers}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text empPresent">On Business</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 ms-2">
          <div class="card shadow-sm dashboard-card" style="background-color: #F8D7E5;">
            <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
              <div class="d-flex white">
                <i class="bi bi-person-slash fa-2x me-3 totalEmployees" style="color: #9B1B30 !important;"></i>
                <div class="ms-auto text-end">
                  <h3 class="card-title mb-0 text-center totalEmployees">{{iosUsers?.iosOffBusinessUsers}}</h3>
                </div>
              </div>
              <div class="text-center">
                <p class="card-text totalEmployees">Off Business</p>
              </div>
            </div>
          </div>
        </div>


      </div>

      <div class="row mt-5 mb-5 pb-5" style="justify-content: center;gap: 50px;">
        <div class="col-lg-5 col-md-6 col-12 mt-2">
          <div class="card p-3 shadow" style="background-color: white;color: black;">
            <apx-chart [series]="chartSeries3" [chart]="chartOptions3" [labels]="chartLabels3"
              [dataLabels]="dataLabels3" [title]="title3" [colors]="colors3" [plotOptions]="plotOptions3">
            </apx-chart>
          </div>
        </div>
        <div class="col-lg-5 col-md-6 col-12 mt-2">
          <div class="card p-3 shadow" style="background-color: white;color: black;">
            <apx-chart [series]="chartSeries4" [chart]="chartOptions4" [labels]="chartLabels4"
              [dataLabels]="dataLabels4" [title]="title4" [colors]="colors4" [plotOptions]="plotOptions4">
            </apx-chart>
          </div>
        </div>
      </div>


    </div>
  </div>
  <!--
    <div class="container pt-4" style="font-size: 1.5rem;color: black;background-color: #FFDAB9;border-radius: 20px;">
      <strong>Unknown Users</strong>
        <div class="row d-flex justify-content-around mt-4">

          <div class="col-md-3">
            <div class="card shadow-sm dashboard-card" style="background-color: #F8ECC8;">
              <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
                <div class="d-flex white">
                  <i class="bi bi-person-lines-fill fa-2x me-3 empPermission" style="color: #AD870C !important;"></i>
                  <div class="ms-auto text-end ">
                    <h3 class="card-title mb-0 text-center empPermission">316</h3>
                  </div>
                </div>
                <div class="text-center">
                  <p class="card-text empPermission">Total Users</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 ms-2">
            <div class="card shadow-sm dashboard-card" style=" background: #DCFFDDF7;">
              <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
                <div class="d-flex white">
                  <i class="bi bi-check-circle fa-2x me-3 empPresent" style="color: #2D702F !important;"></i>
                  <div class="ms-auto text-end">
                    <h3 class="card-title mb-0 text-center empPresent">35</h3>
                  </div>
                </div>
                <div class="text-center">
                  <p class="card-text empPresent">On Business</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 ms-2">
            <div class="card shadow-sm dashboard-card" style="background-color: #F8D7E5;">
              <div class="card-body d-flex flex-column justify-content-between" style="height: 150px;">
                <div class="d-flex white">
                  <i class="bi bi-person-plus fa-2x me-3 totalEmployees" style="color: #9B1B30 !important;"></i>
                  <div class="ms-auto text-end">
                    <h3 class="card-title mb-0 text-center totalEmployees">281</h3>
                  </div>
                </div>
                <div class="text-center">
                  <p class="card-text totalEmployees">Off Business</p>
                </div>
              </div>
            </div>
          </div>


        </div>

      <div class="row mt-5 pb-5" style="justify-content: center;gap: 50px;">
        <div class="col-lg-5 col-md-6 col-12 mt-2">
          <div class="card p-3 shadow" style="background-color: white;color: black;">
            <apx-chart [series]="chartSeries5" [chart]="chartOptions5" [labels]="chartLabels5" [dataLabels]="dataLabels5"
              [title]="title5" [colors]="colors5" [plotOptions]="plotOptions5">
            </apx-chart>
          </div>
        </div>
        <div class="col-lg-5 col-md-6 col-12 mt-2">
          <div class="card p-3 shadow" style="background-color: white;color: black;">
            <apx-chart [series]="chartSeries6" [chart]="chartOptions6" [labels]="chartLabels6" [dataLabels]="dataLabels6"
              [title]="title6" [colors]="colors6" [plotOptions]="plotOptions6">
            </apx-chart>
          </div>
        </div>
      </div>


      </div> -->


</div>